import { useQuery } from '@tanstack/react-query';

/**
 * Hook that return the platform string ('ios' | 'android' | 'web' | undefined).
 */
export function usePlatformDetect() {
  const { data: device, status } = useQuery({
    queryKey: ['GET_DEVICE_PLATFORM'],
    queryFn: async () => {
      if (RUNTIME_ENV === 'native') {
        const { Device } = await import('@capacitor/device');
        const info = await Device.getInfo();
        return info.platform;
      }
      return 'web';
    },
    staleTime: Infinity,
  });

  if (status === 'success') {
    return { status, device };
  }
  return { status, device: undefined };
}
